import { Injectable, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompletionService {
  terminated$: EventEmitter<any> = new EventEmitter<any>();
  completed$: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}

  terminate() {
    this.terminated$.emit();
    parent.postMessage('ConfiguratorClose', environment.webshopUrl);
  }

  complete(configId: string, itemId: string) {
    this.completed$.emit();
    parent.postMessage(`ConfiguratorComplete|${configId}|${itemId}`, environment.webshopUrl);
  }
}
